// extracted by mini-css-extract-plugin
export var infoRow = "_ug-2";
export var labelContainer = "_ug-0";
export var rightInfo = "_ug-1";